import React, {Component} from 'react';
import {Spin, Icon, Row} from 'antd';
import {app, api} from '../../app';
import '../../css/train-certificate.css';
import certificateImg from '../../assets/certificate.jpg';

/**
 * 加载图片
 * @param image
 * @param text
 * @param width
 * @param height
 * @returns {Promise}
 */
function loadImg(image, text, width, height) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve(img);
      console.log(text + '加载完毕');
    };
    img.onerror = (err) => {
      console.error(err);
      app.alert(text + '加载失败！', 'error');
      reject(false);
    };
    img.src = app.urlEncode(image);
    if (width) img.width = width;
    if (height) img.height = height;
    // img.crossOrigin = "Anonymous";
  });
}

CanvasRenderingContext2D.prototype.wrapText = function (text, x, y, maxWidth, lineHeight) {
  if (typeof text !== 'string' || typeof x !== 'number' || typeof y !== 'number') {
    return;
  }

  let context = this;
  let canvas = context.canvas;

  if (typeof maxWidth === 'undefined') {
    maxWidth = (canvas && canvas.width) || 300;
  }
  if (typeof lineHeight === 'undefined') {
    lineHeight = (canvas && parseInt(window.getComputedStyle(canvas).lineHeight)) || parseInt(window.getComputedStyle(document.body).lineHeight);
  }

  // 字符分隔为数组
  let arrText = text.split('');
  let line = '';
  // let rowCount = 0;

  for (let n = 0; n < arrText.length; n++) {
    let testLine = line + arrText[n];
    let metrics = context.measureText(testLine);
    let testWidth = metrics.width;
    if (testWidth > maxWidth && n > 0) {
      // rowCount++
      // if (maxRow && rowCount >= maxRow) {
      //     context.fillText('...', x + maxWidth, y);
      //     break
      // }
      context.fillText(line, x, y);
      line = arrText[n];
      y += lineHeight;
    } else {
      line = testLine;
    }
  }
// else if (maxRow && n >= maxRow){
//         line = testLine + '...';
//         break
//     }
  context.fillText(line, x, y);
};

/**
 * 安排证书画板
 * @returns {Promise<*|void|string>}
 */
async function setCertificateCanvas(data) {
  try {
    const canvas = document.createElement('canvas');
    canvas.style.backgroundColor = '#fff';
    const ctx = canvas.getContext('2d');
    let cer_img = await loadImg(certificateImg, '证件');
    canvas.width = cer_img.width;
    canvas.height = cer_img.height;
    ctx.drawImage(cer_img, 0, 0);
    if (data.icon) {
      let icon_img = await loadImg(data.icon, '技能图标', 400, 400);
      ctx.drawImage(icon_img, 1634, 2740, icon_img.width, icon_img.height);
    }
    if (data.localpath) {
      let localpath_img = await loadImg(data.localpath, '头像', 432, 554);
      ctx.drawImage(localpath_img, 1799, 740.5, localpath_img.width, localpath_img.height);
    }
    if (data.qrcode) {
      let qrcode = await loadImg(data.qrcode, '二维码', 389, 390);
      ctx.drawImage(qrcode, 359, 2731, qrcode.width, qrcode.height);
    }
    ctx.font = '44pt 黑体';
    ctx.fillStyle = '#2A2E3A';
    if (data.acquire_code) {
      let acodes = data.acquire_code.split('').join(' ');
      let acode_x = 1648;
      ctx.fillText(data.acquire_code, acode_x, 608);
      // for (let i = 0; i < acodes.length; i++) {
      //   ctx.fillText(acodes[i], acode_x + (i * 46), 608);
      // }
    }
    ctx.fillText(data.vname || '', 544, 792);//48
    ctx.fillText(data.bsrno || '', 544, 912);
    let time = '';
    if (data.start_time) {
      time = data.start_time;
    }
    if (data.end_time) {
      time += ('～' + data.end_time);
    }
    ctx.fillText(time, 544, 1036);
    ctx.fillText(data.trainame || '', 544, 1156);
    ctx.fillText(data.ppe_level || '', 544, 1276);
    ctx.fillText(data.train_ppe || '', 544, 1399);
    ctx.wrapText(data.fraction || '', 544, 1521, 1700, 72);
    ctx.wrapText(data.train_comment || '', 544, 1763, 1700, 72);
    ctx.fillText(data.acquire_time || '', 1784, 2550);
    return canvas.toDataURL('image/png');
  } catch (e) {
    console.error(e);
    return null;
  }
}

class TrainCertificate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      c_img: null,
      error: null,
      canvas_loading: true,
      info: {},
      reqParams: app.parseQueryString(decodeURIComponent(window.location.href))
    };
  }

  async componentDidMount() {
    document.getElementsByTagName('body')[0].style.width = window.screen.width + 'px';
    document.getElementById('root').style['min-width'] = '0px';
    this._isMounted = true;
    await this.dataSource();
    let c_img = await setCertificateCanvas(this.state.info);
    await this.setData({c_img, canvas_loading: false});
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setData = (data) => app.setStateSync(this, data);

  /**
   * 数据
   * @returns {Promise<void>}
   */
  dataSource = async () => {
    const {reqParams} = this.state;
    const {flag, data, msg} = await app.get(api.GRTrainProof, {
      indexno: reqParams.i,
      id: reqParams.id,
      time: reqParams.t
    });
    if (flag === 1) {
      await this.setData({info: data});
    } else {
      await this.setData({error: msg});
      app.alert(msg, 'error');
    }
  };

  render() {
    let {canvas_loading, c_img, error} = this.state;
    return (
      <div style={{textAlign: 'center', maxWidth: '1000px', margin: '0 auto', fontSize: '1rem'}}>
        {
          canvas_loading ? (
              <Row type="flex" align="middle" justify="space-between">
                <Spin style={{marginTop: 15, marginRight: 15}}/>
                <span>正在加载...</span>
              </Row>) :
            (
              error ? (
                <div style={{marginTop: 15, color: '#999'}}>
                  <Icon type="close-circle" style={{marginRight: 2}}/> {error}
                </div>
              ) : (
                c_img ? (<img src={c_img} alt="证书图片"
                              style={{maxWidth: '100%', width: 'auto', height: 'auto'}}/>) :
                  (
                    <div style={{marginTop: 15, color: '#999'}}>
                      <Icon type="close-circle" style={{marginRight: 2}}/> 加载未成功，请尝试刷新.
                    </div>
                  )
              )
            )
        }
      </div>
    );
  }
}

export default TrainCertificate;



// WEBPACK FOOTER //
// ./src/routes/mobile/TrainCertificate.jsx